<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      title="切换账户"
      :visible="dialogVisible"
      width="800px"
      @close="handleClose"
      append-to-body
      center>
      <el-row class="dialog-change-account">
        <el-col :span="24">
          <div class="header-user-item">
            <img src="@/assets/img/user.png" />
            <span>{{tenantInfo.Account}}</span>
          </div>
        </el-col>
<!--        <el-col :span="8">上班时间：2020/6/12  17:56:47</el-col>-->
<!--        <el-col :span="16">交班时间：2020/6/12  17:56:47</el-col>-->
<!--        <el-col :span="8">应收金额：￥7，376.00</el-col>-->
<!--        <el-col :span="8">线上应收：￥56.00</el-col>-->
<!--        <el-col :span="8">入车流量：186</el-col>-->
<!--        <el-col :span="8">实收金额：￥657.00</el-col>-->
<!--        <el-col :span="8">线上实收：￥56.00</el-col>-->
<!--        <el-col :span="8">出车流量：186</el-col>-->
<!--        <el-col :span="8">免费金额：￥7，376.00</el-col>-->
<!--        <el-col :span="8">线上免费：￥56.00</el-col>-->
<!--        <el-col :span="8">手动开闸：186</el-col>-->
<!--        <el-col :span="8">抵扣金额：￥7，376.00</el-col>-->
<!--        <el-col :span="8">线上抵扣：￥56.00</el-col>-->
<!--        <el-col :span="8">非法开闸：186</el-col>-->
      </el-row>
      <el-row type="flex" justify="center" class="dialog-change-account-form">
        <el-col :span="12">
          <el-form :model="form" ref="form" label-width="120px">
            <el-form-item label="接班操作员账户">
              <el-input v-model="form.Account"></el-input>
            </el-form-item>
            <el-form-item label="密码">
              <el-input placeholder="请输入密码" v-model="form.Password" show-password></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancle">取 消</el-button>
        <el-button type="primary" @click="handleClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import showdialog from '../../../minxs/showdialog'
import { toLogin } from "@/api/module/login";
import { curlSentryUserConfig } from "@/api/module/tenant";
import {
  setToken,
  setUserId,
  setRoleCode,
  setSetFreeOpenGate,
  setLastLoginTime,
} from "@/utils/service";

export default {
  data() {
    return {
      form: {
        Account: '',
        Password: '',
      },
    };
  },
  mixins:[showdialog],
  computed:{
    tenantInfo:function(){
      return this.$store.state.user.userInfo;
    }
  },
  methods: {
    async handleClick() {
      this.$store.dispatch("LogOut");
      let res = await toLogin(this.form);
      if (res.state === "success") {
        let data = res.data;
        setToken(data.Token);
        setUserId(data.Id);
        setRoleCode(data.Role.RoleCode);
        setLastLoginTime(res.data.LastLoginTime);
        this.$store.dispatch("SetUserInfo", data);
        this.$store.dispatch("SetUserName", data.Account);
        this.$store.dispatch("SetIsCashier", data.Role.RoleCode);
        this.$router.push("/home/tenant/");
        this.handleCancle();
        this.$store.dispatch("SetInitWs", true);
        let n = this.$store.state.user.isReLogin;
        ++n;
        this.$store.dispatch("SetIsReLogin", n);
        this.getSetting();
      } else {
        this.$message({
          message: res.message,
          type: 'warning'
        });
      }
    },
    handleCancle() {
      this.handleClose();
      // this.$refs.form.resetFields();
      this.form.Account = '';
      this.form.Password = '';
    },
    getSetting() {
      curlSentryUserConfig().then((res) => {
        if (res.state === "success") {
          setSetFreeOpenGate(res.data.FreeOpenGate)
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
  .dialog-change-account{
    line-height: 2;
  }
  .dialog-change-account-form{
    margin-top: 20px;
    padding-top: 20px;
    background: #FCFCFC;
  }
  .header-user-item {
    display: flex;
    justify-content: left;
    align-items: center;
    & img {
      width: 44px;
      margin-right: 10px;
    }
  }
</style>
